import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { StudentAssignmentOverviewModel } from 'common/models/page-models/student-assignment-overview/student-assignment-overview-model';
import { FormDataService } from '../../base-data-services/form-data.service';
import { DataModel } from 'common/models/utility-models/base-model';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentOverviewDataService extends FormDataService<StudentAssignmentOverviewModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.assignment_details, http, ss);
  }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.assignment_details,
      method: API_METHODS.post,
    };

    return edit;
  }

  createInstance(): StudentAssignmentOverviewModel {
    return new StudentAssignmentOverviewModel();
  }

  override getUpdatePayload(data) {
    const payload = {
      assignment_id: data.assignment_id,
      student_id: data.student_id,
    };
    return payload;
  }



  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    const assignmentDetails = response.details[0] || {}; // Access the first item in the details array

    const returnData = this.customMerge(
      new StudentAssignmentOverviewModel(),
      assignmentDetails
    );

    // Set docPath based on assignment_uploaded_documents availability
    returnData['docPath'] = 
        assignmentDetails.assignment_uploaded_documents &&
        assignmentDetails.assignment_uploaded_documents.length > 0 &&
        response.file_url_path &&
        assignmentDetails.assignment_uploaded_documents[0].document_path
          ? response.file_url_path + assignmentDetails.assignment_uploaded_documents[0].document_path
          : "";

    // Set docAssignmetDownload based on student_doc_url_path and student_file_submit availability
    returnData['docAssignmetDownload'] = 
        assignmentDetails.student_file_submit &&
        response.student_doc_url_path
          ? response.student_doc_url_path + assignmentDetails.student_file_submit
          : "";

    // Assign the entire array if assignment_uploaded_documents are present
    returnData['assignment_uploaded_documents'] = assignmentDetails.assignment_uploaded_documents || [];

    // Map additional fields if required
    returnData['assignment_id'] = assignmentDetails.id || null;
    returnData['topic'] = assignmentDetails.topic || '';
    returnData['description'] = assignmentDetails.description || '';
    returnData['trainer_name'] = assignmentDetails.trainer_name || '';
    returnData['start_date'] = assignmentDetails.start_date || '';
    returnData['end_date'] = assignmentDetails.end_date || '';

    return returnData;
}


  customMerge(obj1: object, obj2: object): any {
    const result: object = {};

    for (const key in obj1) {
      if (obj2.hasOwnProperty(key)) {
        if (obj1.hasOwnProperty(key)) {
          // Custom logic for merging values with the same key
          result[key] = obj2[key];
        }
      }
    }
    return result;
  }
}
